<template>
  <v-dialog
    v-model="show"
    persistent
    width="800px"
  >
    <v-card
      flat
    >
      <v-toolbar
        color="primaryLight"
        dark
        dense
      >
        <v-toolbar-title>Solicitudes de Medios</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-row
          align="center"
          justify="center"
          class="mt-3"
        >
          <v-file-input
            v-model="filesToUpload"
            multiple
            label="Introduzca un archivo PDF"
            variant="filled"
            prepend-icon="mdi-file-pdf-box"
            accept="application/pdf"
          />
          <v-btn
            text
            color="green"
            :disabled="filesToUpload.length === 0"
            @click="subir"
          >
            Subir
          </v-btn>
        </v-row>

        <v-container
          style="overflow-y: auto; height: 55vh"
        >
          <v-row
            v-if="files.length > 0"
          >
            <v-col
              cols="12"
            >
              <v-simple-table
                dense
              >
                <thead>
                  <tr>
                    <th>Archivo</th>
                    <th>Tamaño</th>
                    <th>Fecha</th>
                    <th
                      style="width: 220px"
                    >
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="f in files"
                    :key="f.name"
                  >
                    <td>{{ f.name }}</td>
                    <td>{{ formatSize(f.size) }}</td>
                    <td>{{ f.mtime }}</td>
                    <td
                      class="text-no-wrap"
                    >
                      <v-tooltip
                        bottom
                      >
                        <template
                          #activator="{ on, attrs }"
                        >
                          <v-btn
                            icon
                            v-bind="attrs"
                            aria-label="Abrir"
                            v-on="on"
                            @click="abrir(f.url)"
                          >
                            <v-icon>mdi-open-in-new</v-icon>
                          </v-btn>
                        </template>
                        <span>Abrir</span>
                      </v-tooltip>

                      <v-tooltip
                        bottom
                      >
                        <template
                          #activator="{ on, attrs }"
                        >
                          <v-btn
                            icon
                            v-bind="attrs"
                            aria-label="Descargar"
                            v-on="on"
                            @click="descargar(f.name)"
                          >
                            <v-icon>mdi-file-download-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Descargar</span>
                      </v-tooltip>

                      <v-tooltip
                        bottom
                      >
                        <template
                          #activator="{ on, attrs }"
                        >
                          <v-btn
                            icon
                            color="red"
                            v-bind="attrs"
                            aria-label="Eliminar"
                            v-on="on"
                            @click="eliminar(f.name)"
                          >
                            <v-icon>mdi-delete-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Eliminar</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-row
            v-else
          >
            <v-col
              align="center"
            >
              <p
                class="subtitle-1 black--text"
              >
                No hay solicitudes disponibles.
              </p>
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="red"
            @click="salir"
          >
            Salir
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api'
import constants from '@/helpers/constants'
import dateService from '@/helpers/DateServiceOld'

export default {
  props: {
    show: Boolean,
    idIncendio: String
  },
  data: () => ({
    files: [],
    filesToUpload: [],
    subfolder: 'peticiones_medios'
  }),
  watch: {
    show(val) {
      if (val) this.fetch()
    }
  },
  methods: {
    async fetch() {
      try {
        const res = await api.mediosEstatales.listarSolicitudes(
          this.idIncendio
        )
        const list = res.data || []
        this.files = list.map((x) => ({
          name: x.name,
          size: x.size,
          mtime: dateService.formatDate(x.mtime, 'DD/MM/YYYY HH:mm'),
          url: `${constants.publicBaseUrl}/emergencias/${this.idIncendio}/${
            this.subfolder
          }/${encodeURIComponent(x.name)}`
        }))
      } catch (error) {
        this.$notify('No se pudieron cargar las solicitudes')
      }
    },
    salir() {
      this.$emit('cancelar')
      this.files = []
      this.filesToUpload = []
    },
    async subir() {
      const uploads = this.filesToUpload.map(
        (f) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = async() => {
              const base64 = String(reader.result).split(',')[1]
              try {
                await api.mediosEstatales.uploadSolicitud({
                  idIncendio: this.idIncendio,
                  filename: f.name,
                  fileBase64: base64
                })
                resolve()
              } catch (e) {
                this.$notify('Error al subir el archivo')
                reject(e)
              }
            }
            reader.onerror = reject
            reader.readAsDataURL(f)
          })
      )
      try {
        await Promise.all(uploads)
      } catch (e) {
        this.$notify('Alguna subida de archivos falló')
      } finally {
        this.filesToUpload = []
        await this.fetch()
      }
    },
    abrir(url) {
      window.open(url, '_blank')
    },
    async descargar(name) {
      try {
        const { data } = await api.mediosEstatales.downloadSolicitud(
          this.idIncendio,
          name
        )
        const blob = new Blob([data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
        window.URL.revokeObjectURL(url)
      } catch (e) {
        this.$notify('Error al descargar el archivo')
        throw e
      }
    },
    async eliminar(name) {
      try {
        await api.mediosEstatales.eliminarSolicitud(this.idIncendio, name)
        this.files = this.files.filter((f) => f.name !== name)
      } catch (e) {
        this.$notify('Error al eliminar el archivo')
        throw e
      }
    },
    formatSize(bytes) {
      if (!bytes && bytes !== 0) return ''
      const units = ['B', 'KB', 'MB', 'GB']
      let i = 0
      let v = bytes
      while (v >= 1024 && i < units.length - 1) {
        v /= 1024
        i += 1
      }
      return `${v.toFixed(1)} ${units[i]}`
    }
  }
}
</script>

<style scoped></style>
